var app = angular.module('directives.locationSelect');
app.directive('locationSelect', locationSelect);
// app.directive('locationSelect', ['PortalApi', 'Notification',  'Locations',
function locationSelect() {

    var directive = {
        restrict: 'E',
        scope: {
            inServices:'='
        },
        template: require('../templates/locationSelect.html'),
        controller: ['$rootScope', '$scope', 'Locations','$location', '$timeout', Cntrl]
    };

    function Cntrl($rootScope, $scope, Locations, $location, $timeout) {

        $scope.showLoc = false;
        $scope.hideAll = false;
        $scope.searchText = '';
        $scope.regions = Locations.locations;
        $scope.currLocation = Locations.location;
        $scope.loc = false;
        $scope.searchError = false;
        $scope.regionCounter = 0;   //  was 1,2,3...

        $scope.onlyRegions = [];
        $scope.onlyRegionsKids = [];    // was 0,1,2...
        var children = angular.element(document).find("ul.region-list.search-block")[0].children;

        $scope.saveLoc = function (location) {
            if (location && $scope.doSearch) {
                for(var i = 0; i<$scope.regions.length; i++) {
                    if ($scope.regions[i].name == location.name) {
                        location = $scope.regions[i];
                        Locations.setActive(location);
                        hideList(location);
                        return;
                    }
                }
            } else {
                Locations.setActive(location);
                hideList(location);
            }
        };

        for(var item in $scope.regions){
            $scope.onlyRegions.push($scope.regions[item]);

            for(var elem in $scope.regions[item].kids){
                $scope.onlyRegionsKids.push($scope.regions[item].kids[elem]);
            }
        }

        if (Locations.location.id && Locations.location.id !== 1) {
            $scope.loc = Locations.location;
        }

        // if($location.$$url !== "/main"){ //i don't know  for what this were made. made by rozdobudko
            if ($scope.currLocation.id !== 1){
                $scope.searchText = $scope.currLocation.name;
                $scope.saveLoc($scope.currLocation);
            }
        // }

        $scope.findInRegion = function () {
            $scope.saveLoc($scope.regName);
        };

        document.onkeydown = function(e) {
             if ($scope.showLoc && (e.keyCode == 13 || e.keyCode == 38 || e.keyCode == 40)) {
                 checkElement(e);
             }
             if (e.keyCode == 27 && $scope.showLoc) {
                 $scope.showLoc = false;
                 $scope.$apply();
             }
        };

        $scope.handleKeydown = function(e, action) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                if (action === 'clearValue') {
                    $scope.clearValue();
                }
            }
        };

        function checkElement(e) {

            if (e.keyCode == 38 && $scope.searchText){

                if ($scope.regionCounter){
                    children[$scope.regionCounter-1].classList.remove('chosen-element');
                }

                $scope.regionCounter -= 1;
                if ($scope.regionCounter >= 1){
                    children[$scope.regionCounter-1].classList.add('chosen-element');
                } else{
                    $scope.regionCounter = 0;
                    e.preventDefault();
                }


            } else if(e.keyCode == 40 && $scope.searchText){

                if ($scope.regionCounter){
                    children[$scope.regionCounter-1].classList.remove('chosen-element');
                }

                // children[$scope.regionCounter].classList.add('chosen-element');  // element in children mass 0 but it 1 element
                $scope.regionCounter += 1;

                if ($scope.regionCounter <= children.length){
                    children[$scope.regionCounter-1].classList.add('chosen-element');
                } else{
                    $scope.regionCounter = 0;
                    e.preventDefault();
                }

            } else if(e.keyCode == 13){

                var checkedRegion = children[$scope.regionCounter-1];
                var cityName = angular.element(checkedRegion).find("span > a")[0].innerText;

                for(var i = 0; i < $scope.onlyRegionsKids.length; i++){
                    if ($scope.onlyRegionsKids[i].name == cityName){
                        $scope.saveLoc($scope.onlyRegionsKids[i]);
                        $scope.searchError = false;
                        break;
                    }
                }
                for(var i = 0; i < $scope.onlyRegions.length; i++){
                    if ($scope.onlyRegions[i].name == cityName){
                        $scope.saveLoc($scope.onlyRegions[i]);
                        $scope.searchError = false;
                        break;
                    }
                }
                $timeout(function () {
                    $scope.doSearch = false;
                    $scope.showLoc = false;
                    $scope.regionCounter = 0;
                },0);


            } else{
                return ;
            }
        }

        function hideList(name) {
            $scope.showLoc = false;
            if (!name){
                $scope.searchText = '';
            }
            if (typeof (name) == 'string'){
                $scope.searchText = name;
            }
            if (typeof(name) == 'object' ){
                $scope.searchText = name.name;
            }
        };

        $scope.checkValue = function (value) {
            if (value == "Украина"){
                return;
            }
          if (value){
              $scope.doSearch = true;
          } else{
              $scope.doSearch = false;
          }
        };
        $scope.clearValue = function(){
            $scope.searchError = false;
            $scope.saveLoc();
            $scope.searchText = '';
        };

        $scope.saveRegion = function (regName) {
            $scope.regName = regName;
            $scope.hideAll = true;
        };
        $scope.back = function () {
            $scope.hideAll = false;
        };

        $scope.makeSearch = function (searchPlace) {

            $timeout( function() {
                if (children.length == 0){
                    $scope.searchError = true;
                } else {
                    $scope.searchError = false;
                }
            }, 5);


            if (searchPlace.length == 0){
                $scope.hideAll = false;
                $scope.doSearch = false;
            } else {
                $scope.doSearch = true;
                $scope.regionCounter = 0;
            }
            for(var i = 0; i < children.length;i++){
                children[i].classList.remove('chosen-element');
            }
        };

        $scope.clearLoc = function () {
            hideList();
            $scope.loc = false;
            Locations.setActive();
        };


        $scope.openList = function () {

            $scope.showLoc = !$scope.showLoc;
            if ($scope.showLoc) {
                document.getElementById('city-box').focus();
            }
            for(var i = 0; i < children.length; i++){
                children[i].classList.remove('chosen-element');
            }

        };

        $rootScope.$on('updateLocations', function () {
            $scope.regions = Locations.locations;
        });

        $rootScope.$on('changeLocation', function () {
            var regionList = angular.element(document).find("ul.region-list.search-block");
            var i = 0;

            if (Locations.location.id != 1) {
                $scope.loc = Locations.location;
            }

            if (regionList && regionList.length && regionList[0].children.length) {
                for (var i = 0; i < regionList[0].children.length; i++) {
                    regionList[0].children[i].classList.remove('chosen-element');
                }
            }
        });
    }

    return directive;
}

module.exports = 'directives.locationSelect';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/locationSelect/directives/locationSelect.js
 ** module id = 172
 ** module chunks = 1
 **/